import { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import AppleSignInButton from './AppleSignInButton';
import LegalLink from './LegalLink';

export default function SignInOptions({
  onGoogle,
  onApple,
  showApple,
  appleLoading = false,
  showEmail = false,
  onEmail,
  onLegalNavigate,
}) {
  const [emailOpen, setEmailOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const submitEmail = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password || submitting) return;
    setSubmitting(true);
    try {
      const ok = await onEmail?.(email.trim(), password);
      if (ok) setPassword('');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="flex flex-col gap-3">
      <Button
        type="button"
        onClick={onGoogle}
        className="w-full h-11"
        data-testid="google-signin-btn"
      >
        Sign In with Google
      </Button>
      {showApple && <AppleSignInButton onClick={onApple} loading={appleLoading} />}

      {showEmail && !emailOpen && (
        <button
          type="button"
          onClick={() => setEmailOpen(true)}
          className="text-sm text-muted-foreground hover:text-foreground underline underline-offset-4"
          data-testid="email-signin-toggle"
        >
          Sign in with email
        </button>
      )}

      {showEmail && emailOpen && (
        <form onSubmit={submitEmail} className="flex flex-col gap-2" data-testid="email-signin-form">
          <Input
            type="email"
            autoComplete="username"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="email-signin-email"
          />
          <Input
            type="password"
            autoComplete="current-password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="email-signin-password"
          />
          <Button
            type="submit"
            variant="outline"
            className="w-full h-11"
            disabled={submitting || !email.trim() || !password}
            data-testid="email-signin-submit"
          >
            {submitting ? 'Signing in…' : 'Sign in'}
          </Button>
        </form>
      )}

      <p className="text-xs text-muted-foreground text-center leading-5" data-testid="signin-legal-text">
        By continuing, you agree to our{' '}
        <LegalLink kind="terms" className="underline underline-offset-2 hover:text-foreground" onNavigate={onLegalNavigate} />
        {' '}and{' '}
        <LegalLink kind="privacy" className="underline underline-offset-2 hover:text-foreground" onNavigate={onLegalNavigate} />.
      </p>
    </div>
  );
}
